export const facebookPageInfoFilter = {
  all: ['Basic', 'Posts', 'Ratings', 'Photos', 'CallToActions'],
  basic: ['Basic'],
  posts: ['Basic', 'Posts'],
  ratings: ['Basic', 'Ratings'],
  photos: ['Basic', 'Photos'],
  callToActions: ['Basic', 'CallToActions'],
  postsPhotos: ['Basic', 'Posts', 'Photos'],
};
